// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    ACCOUNTS_CHANGE_STATUS_REQUEST,
    ACCOUNTS_CHANGE_STATUS_REQUEST_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    accountsChangeStatusScheduledResult,
    accountsChangeStatusResult,
} from 'Redux/actions';

// Helpers
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* updateChange({ payload }) {
    try {
        let QUERY = `
            mutation updateCompany ($id: Int!, $status: Int) {
                result: updateCompany (id: $id, status: $status) {
                    id
                    name
                    status
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(accountsChangeStatusResult(data?.result))
        } else yield put(accountsChangeStatusResult({ error: true }))

    } catch (exc) {
        yield put(accountsChangeStatusResult({ error: exc }))
        ExceptionManager(exc, 'Modules/accounts/views/components/changeStatus/redux/saga', 'updateChange');
    }
}

function* createScheduledAction({ payload }){
    try {
        let QUERY = `
            mutation createScheduledAction ($scheduledActions: [ScheduledActionInput], $entityName: String!, $entities: [EntityInput!]) {
                result: createScheduledAction (scheduledActions: $scheduledActions, entityName: $entityName, entities: $entities)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(accountsChangeStatusScheduledResult({ response: data.result }))

    } catch (exc) {
        yield put(accountsChangeStatusScheduledResult({ error: exc.error }))

        ExceptionManager(exc, 'Modules/accounts/views/components/changeStatus/redux/saga', 'createScheduledAction');
    }
}

function* watchMethods() {
    yield takeEvery(ACCOUNTS_CHANGE_STATUS_REQUEST, updateChange);
    yield takeEvery(ACCOUNTS_CHANGE_STATUS_REQUEST_REQUEST, createScheduledAction);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}